import React from "react";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogClose,
} from "../ui/dialog";
import { Input } from "../ui/input";
import { Button } from "../ui/button";

interface CategoryEditModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  value: string;
  categoryId: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSave: (categoryId: string, categoryName: string) => void;
  onCancel: () => void;
  trigger: React.ReactNode;
}

const CategoryEditModal: React.FC<CategoryEditModalProps> = ({
  open,
  onOpenChange,
  value,
  categoryId,
  onChange,
  onSave,
  onCancel,
  trigger,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogTrigger asChild>{trigger}</DialogTrigger>
    <DialogContent className="text-black">
      <DialogHeader>
        <DialogTitle>Edit Category</DialogTitle>
      </DialogHeader>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1 text-black">
            Name
          </label>
          <Input name="category_name" value={value} onChange={onChange} />
        </div>
      </div>
      <DialogFooter className="mt-4">
        <Button
          size="sm"
          onClick={() => onSave(categoryId, value)}
          variant="default"
        >
          Save
        </Button>
        <DialogClose asChild>
          <Button size="sm" onClick={onCancel} variant="outline">
            Cancel
          </Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default CategoryEditModal;
